import type {ReactElement} from 'react';
import {useContext} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {closeModal} from '@Components/modal-container/modal-container-reducer';
import {Panel, PanelContent, PanelHeader} from '@Components/panel';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {ADMIN_IMAGE_SOURCES_PANEL_ID, ADMIN_IMAGE_SOURCES_TITLE} from './email-maker-admin-image-sources-modal.types';
import {ImageSourcesGrid} from './components/image-sources-grid/image-sources-grid';

/** Pre-mounted inside the editor context (reads the live editor); opened via openPanelInModal on the admin button. */
export function EmailMakerAdminImageSourcesModal(): ReactElement | null {
  const {editor} = useContext(emailMakerContext);
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector((s) => s.modals.modalsHashmap[MODALS_IDS.EMAIL_MAKER_ADMIN_IMAGE_SOURCES_MODAL]?.isOpen ?? false);

  if (!isOpen || !editor) {
    return null;
  }

  function handleClose(): void {
    dispatch(closeModal(MODALS_IDS.EMAIL_MAKER_ADMIN_IMAGE_SOURCES_MODAL));
  }

  return (
    <Modal
      modalId={MODALS_IDS.EMAIL_MAKER_ADMIN_IMAGE_SOURCES_MODAL}
      panelId={ADMIN_IMAGE_SOURCES_PANEL_ID}
      modalHeight="fit-content"
      modalMaxHeight="90vh"
      modalWidth="100%"
      modalMaxWidth="900px"
    >
      <Panel
        panelHeader={<PanelHeader title={ADMIN_IMAGE_SOURCES_TITLE} onClose={handleClose} />}
        panelContent={
          <PanelContent>
            <ImageSourcesGrid editor={editor} onComponentSelected={handleClose} />
          </PanelContent>
        }
      />
    </Modal>
  );
}
